import { render, staticRenderFns } from "./payfail.vue?vue&type=template&id=62e7a936"
import script from "./payfail.vue?vue&type=script&lang=js"
export * from "./payfail.vue?vue&type=script&lang=js"
import style0 from "./payfail.vue?vue&type=style&index=0&id=62e7a936&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports